import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/models/api-response.model';
import { Dropdown } from '@core/models/dropdown.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RegistrationParamsHttpService {

  constructor(private http: HttpClient) { }

  getParams(): Observable<string[]> {
    return this.http.get<ApiResponse>(`/registrationdetailparams`).pipe(
      map(res => res.data.rows)
    );
  }
}
